import { useState } from 'react'
import { CheckCircle2, Lock, XCircle } from 'lucide-react'
import { Button, Card, errorToast, toast } from '@/components/ui'
import PasswordField from '@/components/PasswordField'
import { $client } from '@/lib/fetch'
import { validatePassword } from '@/lib/auth'

export default function PasswordChange() {
  const [cur, setCur] = useState('')
  const [next, setNext] = useState('')
  const [confirm, setConfirm] = useState('')
  const [saved, setSaved] = useState(false)
  const [loading, setLoading] = useState(false)

  const mismatch = confirm.length > 0 && next !== confirm
  const weak = next.length > 0 && validatePassword(next) !== null

  const submit = async () => {
    if (mismatch || weak || !next) return
    setLoading(true)
    const r = await $client
      .PATCH('/api/auth/me/password', {
        body: { new_password: next, current_password: cur },
      })
      .finally(() => setLoading(false))

    if (!r.error) {
      setSaved(true)
      setCur('')
      setNext('')
      setConfirm('')
      toast({
        color: 'success',
        title: 'Mot de passe mis à jour avec succès !',
      })
    } else {
      errorToast('Une erreur est survenue', r.error)
    }
  }

  return (
    <Card padding={26}>
      <h2
        style={{
          fontSize: 'var(--text-h4)',
          margin: '0 0 6px',
          fontFamily: 'var(--font-display)',
        }}
      >
        Changer le mot de passe
      </h2>
      <p style={{ fontSize: 14.5, color: 'var(--ink-2)', margin: '0 0 18px' }}>
        Choisissez un mot de passe d'au moins 8 caractères.
      </p>
      <form
        onSubmit={(e) => {
          e.preventDefault()
          submit()
        }}
        style={{ display: 'flex', flexDirection: 'column', gap: 16 }}
      >
        <PasswordField
          label="Mot de passe actuel"
          placeholder="••••••••"
          value={cur}
          onChange={(e) => {
            setCur(e.target.value)
            setSaved(false)
          }}
        />
        <div
          className="oumma-set-grid"
          style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}
        >
          <PasswordField
            label="Nouveau mot de passe"
            placeholder="••••••••"
            value={next}
            onChange={(e) => {
              setNext(e.target.value)
              setSaved(false)
            }}
          />
          <PasswordField
            label="Confirmer"
            placeholder="••••••••"
            value={confirm}
            onChange={(e) => {
              setConfirm(e.target.value)
              setSaved(false)
            }}
          />
        </div>
        {weak && (
          <span
            style={{
              fontSize: 13.5,
              color: 'var(--danger)',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
            }}
          >
            <XCircle size={15} /> {validatePassword(next)}
          </span>
        )}
        {mismatch && (
          <span
            style={{
              fontSize: 13.5,
              color: 'var(--danger)',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
            }}
          >
            <XCircle size={15} /> Les mots de passe ne correspondent pas.
          </span>
        )}
        {saved && (
          <span
            style={{
              fontSize: 14,
              color: 'var(--emerald-700)',
              fontWeight: 600,
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
            }}
          >
            <CheckCircle2 size={16} /> Mot de passe mis à jour avec succès.
          </span>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="primary"
            type="submit"
            loading={loading}
            iconLeft={<Lock size={17} />}
          >
            Mettre à jour le mot de passe
          </Button>
        </div>
      </form>
    </Card>
  )
}
